module.exports = __webpack_public_path__ + "img/pic-08.53ece1d8.jpg";